import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
import TicketsAPI from 'dashboard/api/tickets';

export function useAddAttachmentToTicket() {
  const { t } = useI18n();
  const currentChat = useMapGetter('getSelectedChat');

  const tickets = ref([]);
  const isLoadingTickets = ref(false);
  const isLinking = ref(false);

  const contactId = computed(() => currentChat.value?.meta?.sender?.id);

  const fetchContactTickets = async () => {
    if (!contactId.value) {
      tickets.value = [];
      return;
    }

    isLoadingTickets.value = true;
    try {
      const response = await TicketsAPI.get({ contact_id: contactId.value });
      // Filter to only active tickets (not resolved/closed/cancelled)
      const allTickets = response.data.payload || [];
      tickets.value = allTickets.filter(
        ticket => !['resolved', 'closed', 'cancelled'].includes(ticket.status)
      );
    } catch (error) {
      tickets.value = [];
    } finally {
      isLoadingTickets.value = false;
    }
  };

  const linkAttachmentToTicket = async (ticketDisplayId, attachmentId) => {
    isLinking.value = true;
    try {
      await TicketsAPI.linkAttachment(ticketDisplayId, attachmentId);
      useAlert(t('TICKETS.ATTACHMENTS.LINK_SUCCESS'));
      return true;
    } catch (error) {
      if (error.response?.status === 422) {
        useAlert(t('TICKETS.ATTACHMENTS.ALREADY_LINKED'));
      } else {
        useAlert(t('TICKETS.ATTACHMENTS.LINK_ERROR'));
      }
      return false;
    } finally {
      isLinking.value = false;
    }
  };

  return {
    contactId,
    tickets,
    isLoadingTickets,
    isLinking,
    fetchContactTickets,
    linkAttachmentToTicket,
  };
}
